module.exports = __webpack_public_path__ + "static/media/squire-logo.92f732b2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/receipt/squire-logo.svg
// module id = 488
// module chunks = 0